import { EllipsisVertical } from 'lucide-react'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../../../../../components/ui/popover'
import { RemoveTableCard } from '../../RemoveTableCard'
import { EditTableCard } from '../../EditTableCard'
import { useAuth } from '@/app/hooks/useAuth'

export const SettingsTable = () => {
  const { isSuperAdmin } = useAuth()

  return (
    <Popover>
      <PopoverTrigger>
        <EllipsisVertical />
      </PopoverTrigger>
      <PopoverContent className="w-48 p-0">
        <div className="flex items-center justify-between px-5 pt-6">
          <EditTableCard />
        </div>
        {isSuperAdmin && (
          <>
            <div className="mt-4 w-full border-b-[1px] border-gray01" />
            <div className="flex items-center justify-between px-5 pt-6">
              <RemoveTableCard />
            </div>
          </>
        )}
        <div className="mt-4 w-full border-b-[1px] border-gray01" />
      </PopoverContent>
    </Popover>
  )
}
